import template from './new-name-modal.html';
import { property } from 'lodash-es';
import { actions, selectors } from '../../../../../state';
import './new-name-modal.global.css';
import '@updater-components/cta';

const TOAST_ERROR = 'There was an error saving your name. Please try again.';

class NewNameModalController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      name: {},
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  onSubmit(name) {
    const { dispatch } = this.updStore;

    const success = result => {
      this.close({
        $value: property('meta.response.data.data.id')(result),
      });
    };

    const error = () => {
      dispatch(actions.message.error(TOAST_ERROR));
    };

    dispatch(actions.name.create(name)).then(success, error);
  }
}

export const NewNameModalComponent = {
  template,
  controller: NewNameModalController,
  bindings: {
    close: '&',
    dismiss: '&',
  },
};

function mapStateToThis(state) {
  return {
    submitting: selectors.pending.match(actions.name.isCreate, state),
  };
}
